<template>
  <div id="studentLogin">
    <div class="header">
      <!-- <img src="./img/loginLog.jpg" /> -->
      <div class="title">校园智能体测平台</div>
      <!-- <div class="sub-title">— 登录版 —</div> -->
    </div>
    <div class="contain">
      <form class="login-form">
        <div class="login-form-list">
          <label class="login-form-lable">学&nbsp;校</label>
          <!-- <van-field
  v-model="schoolName"
  is-link
  readonly
  label="学校"
  placeholder="选择学校"
  @click="schoolShowPicker = true"
/> -->
          <input type="text" placeholder="请选择学校" autoComplete="true" v-model="schoolName"
            v-if="schoolColumns.length === 1" readonly/>
          <input type="text" placeholder="请选择学校" autoComplete="true" v-model="schoolName"
            readonly v-else @click="schoolShowPicker = true; schoolType = 1; " />
        </div>
        <div class="login-form-list">
          <label class="login-form-lable">学&nbsp;号</label><input type="snCode" placeholder="请输入学号" autoComplete="true"
            v-model="snCode" />
        </div>
        <div class="login-form-list">
          <label class="login-form-lable">姓&nbsp;名</label><input type="text" placeholder="请输入姓名" autoComplete="true"
            v-model="userName" />
        </div>
        <!-- <div class="login-form-list">
                <label class="login-form-lable">密&nbsp;&nbsp;&nbsp;&nbsp;码</label><input type="password" placeholder="请输入密码" autoComplete="true" v-model="passWord">
            </div> -->
        <button type="button" class="login-form-btn" @click="onSubmit">
          登&nbsp;&nbsp;录
        </button>
      </form>
      <div class="underline" @click="initFrom">遇到问题？</div>
      <!-- <div>{{location}}</div> -->
    </div>
    <!-- 遇到问题弹框 -->
    <van-popup class="information-modal" v-model="informationModal" round>
      <div class="information-title">
        请填写您的基础信息，审核通过后即可登录！
      </div>
      <van-form @submit="onSubmitModal" label-width="30%">
        <van-cell-group inset>
          <van-field v-model="form.studentName" name="studentName" label="姓名" placeholder="请填写姓名" />
          <van-field v-model="form.snCode" name="snCode" label="学号" placeholder="请填写学号" />
          <van-field v-model="form.sexName" name="sexName" label="性别" placeholder="请选择性别" @click="showSexPicker = true" />
          <van-field v-model="form.schoolName" name="schoolName" label="学校" placeholder="请选择学校" @click="schoolShowPicker = true; schoolType = 2;" />
          <van-field v-model="form.departmentName" name="departmentName" label="学院" placeholder="请选择学院"
            @click="pickerDepartment" />
          <van-field v-model="form.className" name="className" label="班级" placeholder="请选择班级" @click="pickerClass" />
          <van-field v-model="form.acadYearCode" name="snCode" label="入学年份" placeholder="请填写入学年份" maxlength="4"
            minlength="4" />
          <van-field v-model="form.phoneNumber" name="phoneNumber" label="身份证号" placeholder="请填写身份证号" />
        </van-cell-group>
        <div class="information-button-box" style="margin: 16px" v-if="showButton">
          <van-button class="information-button" round @click="informationModal = false">
            取消
          </van-button>
          <van-button class="information-button" round color="#1989fa" native-type="submit">
            提交
          </van-button>
        </div>
        <div class="information-info" v-else>已提交，请等待审核</div>
      </van-form>
    </van-popup>
    <!-- 选择性别 -->
    <van-popup v-model="showSexPicker" position="bottom" round>
      <van-picker :columns="sexColumns" show-toolbar @confirm="onSexConfirm" @cancel="showSexPicker = false" />
    </van-popup>
    <!-- 选择学校 -->
    <van-popup v-model="schoolShowPicker" round position="bottom" :style="{ height: '55%' }">
      <van-search v-model="searchvalue" placeholder="请输入搜索关键词进行检索" />
      <van-picker :columns="schoolColumns" :default-index="defaultIndex" show-toolbar @cancel="schoolShowPicker = false"
        @confirm="onConfirmSchool" />
    </van-popup>
    <!-- 选择学院 -->
    <van-popup v-model="departmentShowPicker" round position="bottom" :style="{ height: '55%' }">
      <van-search v-model="searchvalue" placeholder="请输入搜索关键词进行检索" />
      <van-picker :columns="departmentColumns" show-toolbar @cancel="departmentShowPicker = false"
        @confirm="onConfirmDepartment" />
    </van-popup>
    <!-- 选择班级 -->
    <van-popup v-model="classShowPicker" round position="bottom" :style="{ height: '55%' }">
      <van-search v-model="searchValueclass" placeholder="请输入搜索关键词进行检索" />
      <van-picker :columns="classColumns" show-toolbar @cancel="classShowPicker = false" @confirm="onConfirmClass" />
    </van-popup>
    <div id="container" style="display: none"></div>
  </div>
</template>
<script>
import { setSession, setSessionJSON, } from '@/utils/cookie'
import store from '@/store'
import { Notify } from "vant";
import { getSchoolList, Login, getClassInfoByCampusCode, getProcessStudentInfo, getDepartmentToo,getOneSchool } from "@/api/common";
import AMapLoader from '@amap/amap-jsapi-loader'
function getPosition () {
  return new Promise((resolve, reject) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        let latitude = position.coords.latitude
        let longitude = position.coords.longitude
        let data = {
          latitude: latitude,
          longitude: longitude
        }
        resolve(data)
      }, function () {
        reject(arguments)
      })
    } else {
      reject('你的浏览器不支持当前地理位置信息获取')
    }
  })
}
export default {
  name: "Register",
  components: {},
  data() {
    return {
      snCode: "",
      studentName: "",
      openId: "",
      userName: "",
      passWord: "",
      schoolName: "",
      schoolId: "",
      searchvalue: "",
      defaultIndex: "",
      schoolShowPicker: false,
      columnsAll: [],
      schoolColumns: [],
      informationModal: false,
      form: {
        sexName: "",
        sex: 0,
        studentName: "",
        snCode: "",
        schoolName: "",
        schoolId: "",
        departmentName: "",
        departmentId: "",
        className: "",
        classId: "",
        acadYearCode: "",
        phoneNumber: ""
      },
      showSexPicker: false,
      sexColumns: [
        { text: "男", value: "0" },
        { text: "女", value: "1" },
      ],
      searchValueclass: "",
      columnsAllClass: [],
      classColumns: [],
      classShowPicker: false,
      columnsAllDepartment: [],
      departmentColumns: [],
      departmentShowPicker: false,
      schoolType: 1,
      showButton: true,
      lat:'',
      lng:'',
      location:'',
      address: '',
      loading: false,
      isLocation: false
    };
  },
  created() {
    // this.initMap()
    this.openId = this.$route.query.openId;
    this.columnsAll = JSON.parse(sessionStorage.getItem('schoolList')) || []
    this.schoolColumns = JSON.parse(sessionStorage.getItem('schoolList')) || []
    console.log(this.schoolColumns)
    if (this.schoolColumns.length === 1) {
      this.schoolName = this.schoolColumns[0].text
      this.schoolId = this.schoolColumns[0].value
    }
    // this.getSchoolList();
                this.getOneSchool()

  },
  watch: {
    searchvalue(val) {
      console.log(val);
      let search = val;
      this.schoolColumns = this.columnsAll.filter(function (product) {
        console.log("过滤", product);
        let searchField = { text: product.text, value: product.value };
        return Object.keys(searchField).some(function (key) {
          console.log("key值", key);
          return String(product[key]).toLowerCase().indexOf(search) > -1;
        });
      });
    },
    searchValueclass(val) {
      console.log(val);
      let search = val;
      this.classColumns = this.columnsAllClass.filter(function (product) {
        console.log("过滤", product);
        let searchField = { text: product.text, value: product.value };
        return Object.keys(searchField).some(function (key) {
          console.log("key值", key);
          return String(product[key]).toLowerCase().indexOf(search) > -1;
        });
      });
    },
  },
  methods: {
//     getPosition () {
//   return new Promise((resolve, reject) => {
//     if (navigator.geolocation) {
//       navigator.geolocation.getCurrentPosition(function (position) {
//         let latitude = position.coords.latitude
//         let longitude = position.coords.longitude
//         let data = {
//           latitude: latitude,
//           longitude: longitude
//         }
//         resolve(data)
//       }, function () {
//         reject(arguments)
//       })
//     } else {
//       reject('你的浏览器不支持当前地理位置信息获取')
//     }
//   })
// },
      onError (obj) {
      alert(obj.info + '--' + obj.message)
      console.log(obj)
    },
    initMap () {
      AMapLoader.reset()
      AMapLoader.load({
        key: '23e4dea21314779fcd090ef2d9465c4b', // 申请好的Web端开发者Key，首次调用 load 时必填
        version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ['AMap.Geolocation,AMap.Geocoder,AMap.PlaceSearch'] // 插件列表
      })
        .then((AMap) => {
          var that = this
          console.log(AMap)
          that.address = ''
          that.loading = true
          that.isLocation = false

          var map = new AMap.Map('container', {
            resizeEnable: true,
            zoom: 11 // 初始化地图层级,
            // center:that.center
          })
          map.plugin('AMap.Geolocation', function () {
            var geolocation = new AMap.Geolocation({
              enableHighAccuracy: true, // 是否使用高精度定位，默认:true
              timeout: 10000, // 超过10秒后停止定位，默认：5s
              buttonPosition: 'RB', // 定位按钮的停靠位置
              buttonOffset: new AMap.Pixel(10, 20), // 定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
              panToLocation: true, // 定位成功后将定位到的位置作为地图中心点，默认：true
              zoomToAccuracy: true // 定位成功后是否自动调整地图视野到定位点
              // noIpLocate:1,//3: 所有终端禁止使用IP定位
            })
            map.addControl(geolocation)
            geolocation.getCurrentPosition(function (status, result) {
              if (status === 'complete') {
                console.log(result)
                that.lat = result.position.lat
                that.lng = result.position.lng
                that.getOneSchool()

                // that.onComplete();
                that.location =
                  '当前位置 经度:' +
                  result.position.lng +
                  ',' +
                  '纬度:' +
                  result.position.lat
              } else {
                console.log(result)
                that.loading = false
                that.isLocation = false
                // Dialog.alert({ title: '定位失败', message: '疑似无定位权限，请至手机设置中开启微信的定位权限！' }).then(() => { // on close
                // })
              }
            })
          })
        
        })
        .catch((e) => {
          console.log(e)
        })
    },
    getOneSchool () {
      getPosition().then(result => {
        this.location = result
        console.log(result);
        // 返回结果示例：
        // {latitude: 30.318030999999998, longitude: 120.05561639999999}
        // 一般小数点后只取六位，所以用以下代码搞定
        getOneSchool({ latitude: result.latitude, longitude: result.longitude }).then(dl => {
         if (dl.data.body.length > 0) {
          this.schoolName = dl.data.body[0].schName
          this.schoolId = dl.data.body[0].schCode
          this.form.schoolName =  dl.data.body[0].schName;
          this.form.schoolId =dl.data.body[0].schCode;
        }
      })
        console.log(queryData)
        // 以下放置获取坐标后你要执行的代码:
        // ...
      }).catch(err => {
        console.log(err)
      })
      // getOneSchool({ latitude: this.lat, longitude: this.lng }).then(dl => {
      //   console.log(dl.body)
      //   if (dl.body.length > 0) {
      //     this.schoolName = dl.body[0].schName
      //     this.schoolId = dl.body[0].schCode
      //     this.form.schoolName =  dl.body[0].schName;
      //     this.form.schoolId =dl.body[0].schCode;
      //   }
      // })
      // const geo = window.navigator.geolocation
      // const that = this
      // console.log(geo)
      // this.$toast.loading({
      //   duration: 0,
      //   message: '加载中...',
      //   forbidClick: true
      // })
      // geo.getCurrentPosition(function (res) {
      //   console.log(res)
      //   const lat = res.coords.latitude
      //   const lon = res.coords.longitude

      // })
    },
    // getSchoolList() {
    //   getSchoolList().then((res) => {
    //     this.columnsAll = res.data.body.map((item) => {
    //     //         if (item.name=='龙猫大学') {
    //     //   this.schoolName = item.name
    //     //   this.schoolId = item.code
    //     //    this.form.schoolName = item.name;
    //     // this.form.schoolId = item.code;
    //     // }
    //       return { text: item.name, value: item.code };
    //     });
    //     this.schoolColumns = res.data.body.map((item) => {
    //       return { text: item.name, value: item.code };
    //     });
    //   });
    // },
    getDepartmentList() {
      getDepartmentToo({ schoolId: this.form.schoolId }).then((res) => {
        this.columnsAllDepartment = res.data.data.map((item) => {
          return { text: item.departmentName, value: item.departmentCode };
        });
        this.departmentColumns = res.data.data.map((item) => {
          return { text: item.departmentName, value: item.departmentCode };
        });
      });
    },
    getClassList() {
      getClassInfoByCampusCode({ schoolId: this.form.schoolId }).then((res) => {
        this.columnsAllClass = res.data.data.map((item) => {
          return { text: item.className, value: item.classCode };
        });
        this.classColumns = res.data.data.map((item) => {
          return { text: item.className, value: item.classCode };
        });
      });
    },
    pickerDepartment() {
      if (this.form.schoolId) {
        this.departmentShowPicker = true
      } else {
        Notify({ type: "warning", message: "请先选择学校" });
      }
    },
    pickerClass() {
      if (this.form.schoolId) {
        this.classShowPicker = true
      } else {
        Notify({ type: "warning", message: "请先选择学校" });
      }
    },
    onConfirmSchool(val) {
      if (this.schoolType === 1) {
        this.schoolName = val.text;
        this.schoolId = val.value;
        this.schoolShowPicker = false;
      } else {
        this.form.schoolName = val.text;
        this.form.schoolId = val.value;
        this.schoolShowPicker = false;
        this.getDepartmentList();
        this.getClassList();
      }
    },
    onConfirmDepartment(val) {
      this.form.departmentName = val.text;
      this.form.departmentId = val.value;
      this.departmentShowPicker = false;
    },
    onConfirmClass(val) {
      this.form.className = val.text;
      this.form.classId = val.value;
      this.classShowPicker = false;
    },
    onSubmit() {
      if (this.schoolId === "") {
        Notify({ type: "warning", message: "请选择学校" });
        return;
      }
      if (this.snCode === "") {
        Notify({ type: "warning", message: "请输入学号" });
        return;
      }

      if (this.userName === "") {
        Notify({ type: "warning", message: "请输入姓名" });
        return;
      }
      const parame = {
        studentName: this.userName,
        passWord: this.passWord,
        schoolId: this.schoolId,
        snCode: this.snCode,
        schoolCode: this.schoolId,
        openId: this.openId
      }
      Login(parame).then((res) => {
        let obj = res.data.obj;
        obj.type = res.data.type;
        obj.token = res.data.token;
        obj.hasOpenId = false;
        obj.schoolCode = this.schoolId,
         obj.appid = window.context.VITE_APPID;
        localStorage.setItem("login", JSON.stringify(parame));
        store.commit('SER_USER_INFO', obj)
        setSessionJSON('userInfo', obj)
        setSession('Authorization', obj.token)
        this.$router.push({
          path: "/myFitness",
        });
      });
    },
    initFrom() {
      this.form.studentName = "";
      this.form.snCode = "";
      this.form.sex = 0;
      this.form.sexName = "";
      this.form.schoolName = "";
      this.form.schoolId = "";
      this.form.departmentName = "";
      this.form.departmentId = "";
      this.form.className = "";
      this.form.classId = "";
      this.form.acadYearCode = "";
      this.form.phoneNumber = "";
      this.informationModal = true;
    },
    onSubmitModal() {
      if (this.form.studentName === "") {
        Notify({ type: "warning", message: "请输入姓名" });
        return;
      }
      if (this.form.snCode === "") {
        Notify({ type: "warning", message: "请输入学号" });
        return;
      }
      if (this.form.sex === "") {
        Notify({ type: "warning", message: "请选择性别" });
        return;
      }

      if (this.form.schoolId === "") {
        Notify({ type: "warning", message: "请选择学校" });
        return;
      }
      if (this.form.departmentId === "") {
        Notify({ type: "warning", message: "请选择学院" });
        return;
      }
      if (this.form.classId === "") {
        Notify({ type: "warning", message: "请选择班级" });
        return;
      }
      if (this.form.acadYearCode === "") {
        Notify({ type: "warning", message: "请填写年份" });
        return;
      }
      if (this.form.phoneNumber === "") {
        Notify({ type: "warning", message: "请输入身份证" });
        return;
      }
      getProcessStudentInfo({
        fitnessAchievementAppeal: {
          studentName: this.form.studentName,
          snCode: this.form.snCode,
          sex: this.form.sex,
          departmentCode: this.form.departmentId,
          departmentName: this.form.departmentName,
          classCode: this.form.classId,
          className: this.form.className,
          acadYearCode: this.form.acadYearCode,
          phoneNumber: this.form.phoneNumber
        },
        schoolId: this.form.schoolId
      }).then(({ data }) => {
        if (data.status === '00') {
          this.showButton = false;
          return Notify({ type: "success", message: data.msg });
        }

      });
    },
    onSexConfirm(val) {
      this.form.sex = val.value;
      this.form.sexName = val.text;
      this.showSexPicker = false;
    },
    showInformationModal() {
      this.informationModal = false;
    },
  },
};
</script>

<style lang="less" scoped>
#studentLogin {
  padding: 0 0 5vw;
  background: #ffffff;
  width: 100%;
  min-height: 100vh;
  font-size: 16px;

  .header {
    padding: 15% 0 20%;
    text-align: center;
    width: 100%;
    color: #000000;

    img {
      width: 25%;
      height: auto;
    }

    .title {
      font-size: 24px;
      line-height: 50px;
    }
  }

  .contain {
    padding: 0 15%;
    width: 100%;
    box-sizing: border-box;

    .login-form-list {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      padding: 15px 20px;
      border: 1px solid #d2d2d2;
      color: #727272;
      border-radius: 30px;

      input {
        width: 70%;
        border: none;
        box-sizing: border-box;
      }
    }

    button {
      margin-top: 10%;
      width: 100%;
      height: 50px;
      border: none;
      background: #3460e7;
      border-radius: 25px;
      color: #ffffff;
    }

    .underline {
      margin-top: 5vw;
      text-decoration: underline;
      text-align: center;
      color: #727272;
    }
  }

  .information-modal {
    padding: 5vw 0 0;
    width: 80vw;
    min-height: 115vw;
    box-sizing: border-box;

    .information-title {
      margin-bottom: 5vw;
      padding: 0 10vw;
      text-align: center;
    }

    .information-button-box {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .information-button {
        width: 35vw;
      }
    }

    .information-info {
      margin: 5vw 0;
      text-align: center;
    }
  }
}</style>
